import styled from 'styled-components';

export default {
    SmsBlockContainer: styled.div.attrs({ className: 'sms-block-container' })`
        width: auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    `,
    SmsBlockTitle: styled.h4.attrs({ className: 'sms-block-title' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 32px;
        letter-spacing: 0.5px;
        color: ${props => props.error ? ' #B12A31' : '#1A1A1A'};
        font-weight: 400;
        margin: 0 0 10px;
        
        @media(min-width: 900px){
            font-size: 18px;
            line-height: 32px;
            letter-spacing: 0.5px;
            margin-bottom: 20px;
        }
    `,
    SmsBlockInputContainer: styled.div.attrs({ className: 'sms-block-input-container' })`
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 0;
        @media(max-width: 700px) {
            width: 100%;
        }
    `,
    SmsBlockButton: styled.button.attrs({ className: 'sms-block-button' })`
        margin-right: 10px;
        padding: 0 20px;
        border: none;
        background: ${props => props.isPending ? '#B9C0C2' : props.isConfirmed ? '#FFFFFF' : '#1A1A1A'};
        box-sizing: border-box;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        line-height: 1;      
        text-align: center;
        letter-spacing: ${props => props.isPending ? '0.5px' : '1px'};
        font-size: ${props => props.isPending ? '18px' : '11px'};
        font-weight: ${props => props.isPending ? '400' : 'bold'};
        
        text-transform: uppercase;
        color: ${props => props.isPending ? '#1A1A1A' : '#FFF'};
        outline: none;
        flex-grow: 1;
        cursor: ${props => props.isConfirmed ? 'default' : 'pointer'};
        width: 176px;
        height: 48px;
        &:focus {
            // we need some styles
        }
        @media (max-width: 320px) {
            width: 100%;
            max-width: 100%;
        }
    `,
    SmsBlockInput: styled.input.attrs({ className: 'sms-block-input' })`
        background: #F0F0F0;
        border: 1px solid #B9C0C2;
        box-sizing: border-box;
        width: 107px;
        height: 48px;
        caret-color: #000;
        padding: 12px 35px;
        outline: none;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 19px;
        color:#5B6164;
    `,
    SmsBlockError: styled.span.attrs({ className: 'sms-block-error' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 32px;
        letter-spacing: 0.5px;
        color: #B12A31;
        
        @media(min-width: 900px){
            font-size: 18px;
            line-height: 32px;
            letter-spacing: 0.5px;
        }
    `,
    TimerComponent: styled.div.attrs({ className: 'timer-component' })`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    TimerLoader: styled.div.attrs({ className: 'timerLoader' })`
        margin-right: 10px;
        width: 20px;
        height: 20px;
        mix-blend-mode: normal;
        opacity: 0.6;
        border: 1px solid #020202;
        border-left: none;
        border-bottom: none;
        border-radius: 100%;
        box-sizing: border-box;
        animation: 1s linear 0s normal none infinite running rotate;
        @keyframes rotate {
            0% {
                transform: rotate(0deg);
            }
              100% {
                transform: rotate(360deg);
            }
        }
    `,
};
